<template>
  <section class="mqtt-card" :class="tone">
    <div v-if="title || $slots.action" class="mqtt-card__header">
      <h2>{{ title }}</h2>
      <slot name="action" />
    </div>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'MqttDashboardCard',
  props: { title: { type: String, default: '' }, tone: { type: String, default: '' } },
}
</script>

<style scoped>
.mqtt-card { background: linear-gradient(135deg, #102a47, #0b1d35); border: 1px solid #1e4b70; border-radius: 14px; color: #e5f4ff; padding: 18px; height: 100%; box-shadow: 0 12px 24px rgba(0, 0, 0, .14); }
.mqtt-card__header { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 14px; }
.mqtt-card h2 { color: #d9f8ff; font-size: 1rem; font-weight: 700; letter-spacing: .02em; margin: 0; }
.mqtt-card.success { background: linear-gradient(135deg, #102f38, #0c2434); border-color: #1c7a77; }
.mqtt-card.warning { background: linear-gradient(135deg, #302812, #1a2634); border-color: #8a6420; }
.mqtt-card.danger { background: linear-gradient(135deg, #341d2b, #142238); border-color: #873849; }
</style>
